import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { ProfilesStepBarPrpps } from './types';

type Props  = ProfilesStepBarPrpps & {
  containerRef: React.RefObject<HTMLUListElement>;
  itemRefs: React.MutableRefObject<(HTMLLIElement | null)[]>;
};

export const Presentation: FunctionComponent<Props> = ({
  enforceFlag,
  steps,
  currentIndex,
  completedKeys,
  onChangeStep,
  containerRef,
  itemRefs,
}) => {
  return (
    <ul className="progress-indicator progress-indicator--modal" ref={containerRef}>
      {steps.map((step, index) => {
        const isCurrent = index === currentIndex;
        const isComplete = completedKeys.includes(step.key);
        return (
          <React.Fragment key={step.key}>
            {/* STEP */}
            <li
              ref={(el) => (itemRefs.current[index] = el)}
              className={classnames('progress-indicator__step', {
                'progress-indicator__step--current': isCurrent,
                'progress-indicator__step--complete': isComplete,
                'progress-indicator__step--clickable': !enforceFlag,
                'last': index === steps.length - 1,
              })}
              onClick={!enforceFlag ? () => onChangeStep(index) : undefined}
            >
              <span className="progress-indicator__icon">
                {isComplete ? (
                  <svg width="23" height="23" viewBox="0 0 23 23">
                    <circle cx="11.5" cy="11.5" r="11" fill="#007800" />
                    <path
                      d="M10.0968 15L7 11.6638L7.6 11.02L10.0968 13.72L15.4 8L16 8.64L10.0968 15Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg width="23" height="23" viewBox="0 0 23 23">
                    <circle cx="11.5" cy="11.5" r="11" stroke={isCurrent ? '#78AE78' : '#19190F'} fill="none" />
                    <text
                      x="50%"
                      y="50%"
                      dominantBaseline="middle"
                      textAnchor="middle"
                      fontSize="10"
                      fill={isCurrent ? '#78AE78' : '#19190F'}
                    >
                      {index + 1}
                    </text>
                  </svg>
                )}
              </span>
              <span className="progress-indicator__label">
                {step.label}
              </span>
            </li>
            {/* ARROW */}
            {index !== steps.length - 1 && (
              <li className="progress-indicator__arrow">
                <svg width="6" height="9" viewBox="0 0 6 9">
                  <path
                    d="M5.5 4.5L1.13 8.87L0.5 8.24L4.25 4.5L0.51 0.76L1.14 0.13L5.5 4.5Z"
                    fill="#19190F"
                  />
                </svg>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};
